import {all, equals, isNotEmpty, pluck} from 'ramda';

import type {CellValues} from '../types/CellValues';

export const getCurrencyAcrossCells = (selectedCells: CellValues) =>
  isNotEmpty(selectedCells) &&
  all(equals(selectedCells[0].currency), pluck('currency', selectedCells))
    ? selectedCells[0].currency
    : null;
